<template>
  <div>
    <div class="h-100 mx-0 d-flex">
      <b-col
        v-if="!$device.isMobile"
        class="p-0 h-100 d-flex align-items-center"
      >
        <div class="wrap-banner d-flex flex-column w-100 h-100">
          <div class="app-title text-center">
            <img
              class="mx-auto logo mb-4"
              width="200px"
              height="76px"
              :srcset="
                require('@/assets/img/logo-black-transparent.svg?srcset')
              "
            />
            <div class="title text-40 font-weight-bold mb-2">
              {{ $t('課程平台') }}
            </div>
            <div class="text-18 mb-5">
              {{ $t('一站式課程學習平台，手機 APP 也可以使用喔！') }}
            </div>
          </div>
          <div
            class="banner-container position-relative d-flex flex-colunm justify-content-center h-100"
          >
            <img
              v-i18n-src="
                '@/assets/img/locales/{locale}/login/web_login_banner.png'
              "
              class="d-block banner"
            />
          </div>
        </div>
      </b-col>
      <div class="login-container">
        <div
          class="upper-bg d-flex flex-column align-items-center justify-content-center"
        >
          <div
            v-if="$device.isMobile"
            class="position-absolute"
            :style="{
              width: '100%',
              top: 0,
            }"
          >
            <img
              class="d-block"
              :src="LoginBgTop"
              :style="{
                'object-fit': 'cover',
                width: '100%',
              }"
            />
            <div
              class="position-absolute font-weight-bold p-3 top-0 left-0 d-flex align-items-center"
              @click="openChangeLocaleModal"
            >
              <i class="icon-world text-24 mr-1"></i>
              {{ localeName }}
            </div>
            <div
              class="position-absolute font-weight-bold p-3 top-0 right-0"
              @click="gotoWitQuery('signup')"
            >
              {{ $t('註冊') }}
            </div>
          </div>
          <div class="position-fixed top-0 right-0">
            <b-dropdown
              v-if="!$device.isMobile"
              variant="light"
              size="sm"
              no-caret
              class="font-weight-bold m-3 login-locale"
            >
              <template #button-content>
                <div class="d-flex align-items-center">
                  <i class="icon-world text-24 mr-1"></i>
                  {{ localeName }}
                </div>
              </template>
              <template v-for="locale in localeList">
                <b-dropdown-item
                  :key="locale.code"
                  @click="changeLocale(locale.code)"
                >
                  {{ locale.name }}
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </div>

          <div class="content d-flex h0">
            <div class="p-0" :style="upperBgWidth">
              <div class="mb-4">
                <div class="hello w-100 text-center font-weight-bold mb-2">
                  {{ $t(activeTab === 'phone' ? '手機登入' : '信箱登入') }}
                </div>
              </div>

              <div v-show="activeTab === 'email'">
                <b-form
                  v-if="loginMethods.includes('email')"
                  @submit.prevent="requestLogin('email')"
                >
                  <b-form-group label-for="email" class="account-input">
                    <b-form-input
                      id="email"
                      ref="email"
                      v-model="$v.formData.email.$model"
                      name="email"
                      aria-describedby="input-email-feedback"
                      :placeholder="$t('請輸入帳號或電子信箱')"
                      :state="formData.isUsernameValid"
                      @input="usernameInputHandler"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-phoneNum-feedback"
                      :state="formData.isUsernameValid"
                      class="mt-0"
                    >
                      <div v-if="!$v.formData.email.required" class="error">
                        {{ $t('請輸入帳號或電子信箱') }}
                      </div>
                      <div
                        v-else-if="backendError === 'User not exist!'"
                        class="error"
                      >
                        {{ $t('帳號或電子信箱尚未註冊') }}
                      </div>
                      <div
                        v-else-if="backendError === '帳號被禁止'"
                        class="error"
                      >
                        {{ $t('您的帳號已被停用') }}
                      </div>
                      <div v-else-if="$v.formData.email.$invalid" class="error">
                        {{ $t('請輸入正確的帳號或電子信箱') }}
                      </div>
                      <div v-else class="error">
                        {{ $t('伺服器發生錯誤，請稍後再試') }}
                      </div>
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label-for="passwordForEmail">
                    <div class="d-flex align-items-center">
                      <b-form-input
                        id="passwordForEmail"
                        ref="password"
                        v-model="$v.formData.password.$model"
                        name="password"
                        aria-describedby="input-password-feedback"
                        :type="showPassword ? 'text' : 'password'"
                        maxlength="15"
                        :placeholder="$t('請輸入8-15位密碼')"
                        :state="formData.isPasswordValid"
                        @input="passwordInputHandler"
                      ></b-form-input>
                      <i
                        class="text-32 text-primary ml-2 cursor-pointer d-block"
                        :class="showPassword ? 'icon-View' : 'icon-Eye-off'"
                        @click="showPassword = !showPassword"
                      ></i>
                    </div>
                    <b-form-invalid-feedback
                      id="input-password-feedback"
                      :state="formData.isPasswordValid"
                      class="mt-0"
                    >
                      <div v-if="!$v.formData.password.required" class="error">
                        {{ $t('請輸入密碼') }}
                      </div>
                      <div
                        v-else-if="!$v.formData.password.minLength"
                        class="error"
                      >
                        {{ $t('不能少於8碼') }}
                      </div>
                      <div
                        v-else-if="backendError === 'Wrong password!'"
                        class="error"
                      >
                        {{ $t('密碼錯誤') }}
                      </div>
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <button
                    type="submit"
                    class="w-100 btn btn-secondary"
                    size="md"
                  >
                    {{ $t('登入') }}
                  </button>
                </b-form>
              </div>
              <div v-show="activeTab === 'phone'">
                <b-form
                  v-if="loginMethods.includes('phone')"
                  @submit.prevent="requestLogin('phone')"
                >
                  <b-form-group label-for="phoneNum" class="account-input">
                    <b-input-group>
                      <b-button
                        v-if="$device.isMobile"
                        class="region d-flex align-items-center justify-content-between pl-3 text-center"
                        size="md"
                        @click="isRegionEditing = true"
                      >
                        <span>{{ formData.currentCallingCode }}</span>
                        <i class="icon-Chevron-down"></i>
                      </b-button>
                      <b-dropdown
                        v-else
                        toggle-class="customDropdown"
                        size="md"
                        variant="none"
                        :text="formData.currentCallingCode"
                        no-caret
                      >
                        <template #button-content>
                          <div class="d-flex align-items-center">
                            {{ formData.currentCallingCode }}
                            <i
                              class="icon-Chevron-down ml-2"
                              style="color: #ff855e"
                            ></i>
                          </div>
                        </template>
                        <b-dropdown-item
                          v-for="regionCode in regionCodes"
                          :key="regionCode.code"
                          @click="
                            sheetEvent(
                              regionCode.callingCode,
                              regionCode.regionCode
                            )
                          "
                          >{{ $t(regionCode.region) }}
                          {{ regionCode.callingCode }}
                        </b-dropdown-item>
                      </b-dropdown>
                      <b-form-input
                        id="phoneNum"
                        ref="phoneNum"
                        v-model="$v.formData.phoneNum.$model"
                        name="phoneNum"
                        aria-describedby="input-phoneNum-feedback"
                        type="tel"
                        :placeholder="$t('請輸入手機號碼')"
                        :state="formData.isUsernameValid"
                        @input="usernameInputHandler"
                      ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback
                      id="input-phoneNum-feedback"
                      :state="formData.isUsernameValid"
                      class="mt-0"
                    >
                      <div v-if="!$v.formData.phoneNum.required" class="error">
                        {{ $t('請輸入手機號碼') }}
                      </div>
                      <div
                        v-else-if="backendError === 'User not exist!'"
                        class="error"
                      >
                        {{ $t('手機號碼尚未註冊') }}
                      </div>
                      <div
                        v-else-if="backendError === '帳號被禁止'"
                        class="error"
                      >
                        {{ $t('您的帳號已被停用') }}
                      </div>
                      <div
                        v-else-if="
                          !$v.formData.phoneNum.isValid ||
                          backendError === 'wrong format'
                        "
                        class="error"
                      >
                        {{ $t('請輸入正確的手機號碼') }}
                      </div>
                      <div v-else class="error">
                        {{ $t('伺服器發生錯誤，請稍後再試') }}
                      </div>
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label-for="passwordForPhone">
                    <div class="d-flex align-items-center">
                      <b-form-input
                        id="passwordForPhone"
                        ref="password"
                        v-model="$v.formData.password.$model"
                        name="password"
                        aria-describedby="input-password-feedback"
                        :type="showPassword ? 'text' : 'password'"
                        maxlength="15"
                        :placeholder="$t('請輸入8-15位密碼')"
                        :state="formData.isPasswordValid"
                        @input="passwordInputHandler"
                      ></b-form-input>
                      <i
                        class="text-32 text-primary ml-2 cursor-pointer d-block"
                        :class="showPassword ? 'icon-View' : 'icon-Eye-off'"
                        @click="showPassword = !showPassword"
                      ></i>
                    </div>
                    <b-form-invalid-feedback
                      id="input-password-feedback"
                      :state="formData.isPasswordValid"
                      class="mt-0"
                    >
                      <div v-if="!$v.formData.password.required" class="error">
                        {{ $t('請輸入密碼') }}
                      </div>
                      <div
                        v-else-if="!$v.formData.password.minLength"
                        class="error"
                      >
                        {{ $t('不能少於8碼') }}
                      </div>
                      <div
                        v-else-if="backendError === 'Wrong password!'"
                        class="error"
                      >
                        {{ $t('密碼錯誤') }}
                      </div>
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <button
                    type="submit"
                    class="w-100 btn btn-secondary"
                    size="md"
                  >
                    {{ $t('登入') }}
                  </button>
                </b-form>
              </div>

              <div
                style="flex-wrap: wrap; justify-content: center; row-gap: 4px"
                class="d-flex align-items-center mt-1 text-12"
              >
                <b-form-checkbox
                  id="remember-account"
                  v-model="isAccountRemembered"
                  class="d-flex align-items-center"
                  style="font-size: 16px; min-width: 50%"
                  name="remember-account"
                >
                  <span
                    style="font-size: 12px; position: relative; top: -1px"
                    >{{ $t('記住帳號') }}</span
                  >
                </b-form-checkbox>
                <span
                  v-if="activeTab === 'activity' && false"
                  class="forget cursor-pointer"
                >
                  <span
                    class="cursor-pointer"
                    @click="onClickOpenActivityInfoModal"
                  >
                    {{ $t('資訊說明') }}
                  </span>
                </span>
                <span
                  v-else-if="activeTab !== 'activity'"
                  class="forget"
                  style="min-width: 50%; text-align: right"
                >
                  <span
                    class="cursor-pointer"
                    @click="gotoWitQuery('forget-password')"
                  >
                    {{ $t('忘記密碼？') }}
                  </span>
                </span>
              </div>
              <!-- 快速註冊/登入方式 -->
              <div class="thirdparty-login-text text-14 my-4">
                <div class="dash flex-fill mr-3"></div>
                <div class="text-content">
                  {{ $t('其他登入方式') }}
                </div>
                <div class="dash flex-fill ml-3"></div>
              </div>
              <div class="d-flex justify-content-center">
                <AppleLoginButton
                  v-if="loginMethods.includes('apple') && !isAndroid"
                  class="wrap-oauth-login-btn"
                >
                  <div class="oauth-login-btn">
                    <img :src="AppleIcon" />
                  </div>
                  <div v-show="!isIos" class="oauth-login-btn-text">Apple</div>
                </AppleLoginButton>
                <GoogleLoginButton
                  v-if="loginMethods.includes('google')"
                  class="wrap-oauth-login-btn"
                >
                  <div class="oauth-login-btn">
                    <img :src="GoogleIcon" />
                  </div>
                  <div v-show="!isIos" class="oauth-login-btn-text">Google</div>
                </GoogleLoginButton>
                <LineLoginButton
                  v-if="loginMethods.includes('line')"
                  class="wrap-oauth-login-btn"
                >
                  <div class="oauth-login-btn">
                    <img :src="LineIcon" />
                  </div>
                  <div v-show="!isIos" class="oauth-login-btn-text">LINE</div>
                </LineLoginButton>
                <GuestLoginButton
                  v-if="loginMethods.includes('guest')"
                  class="wrap-oauth-login-btn"
                >
                  <div class="oauth-login-btn">訪客</div>
                  <div v-show="!isIos" class="oauth-login-btn-text">訪客</div>
                </GuestLoginButton>
                <div
                  v-show="activeTab === 'email'"
                  class="wrap-oauth-login-btn"
                  @click="initialData('phone')"
                >
                  <div class="oauth-login-btn">
                    <i class="icon-Phone text-24"></i>
                  </div>
                  <div v-show="!isIos" class="oauth-login-btn-text">
                    {{ $t('手機') }}
                  </div>
                </div>
                <div
                  v-show="activeTab === 'phone'"
                  class="wrap-oauth-login-btn"
                  @click="initialData('email')"
                >
                  <div class="oauth-login-btn">
                    <i class="icon-Email text-24"></i>
                  </div>
                  <div v-show="!isIos" class="oauth-login-btn-text">
                    {{ $t('信箱') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            v-if="$device.isMobile"
            class="d-block position-absolute"
            :src="LoginBgBottom"
            :style="{
              'object-fit': 'cover',
              width: '100%',
              bottom: 0,
            }"
          />
        </div>
        <div
          v-if="!$device.isMobile"
          class="bottom-bg d-flex align-items-center justify-content-center"
        >
          <div class="no-account">
            <span>{{ $t('還沒有帳號？') }}</span>
            <span
              class="signup cursor-pointer"
              @click="gotoWitQuery('signup')"
              >{{ $t('前往註冊') }}</span
            >
          </div>
        </div>
      </div>
      <action-sheet
        v-if="isRegionEditing && $device.isMobile"
        :title="$t('國家/地區')"
        :touch-move-to-close="true"
        sheet-height="260"
        @close="closeEdit"
      >
        <ul class="list-group">
          <li
            v-for="regionCode in regionCodes"
            :key="regionCode.code"
            class="avatar list-group-item-action d-flex align-items-center pl-3"
            @click="sheetEvent(regionCode.callingCode, regionCode.regionCode)"
          >
            <span class="mr-2">{{ $t(regionCode.region) }}</span>
            <span>{{ regionCode.callingCode }}</span>
          </li>
        </ul>
      </action-sheet>
    </div>

    <div v-if="$device.isMobile">
      <PageInfo :visible="isActivityInfoModalShow" @close="closeActivityInfo">
        TODO
      </PageInfo>
    </div>
    <ModalInfo
      v-else
      :visible="isActivityInfoModalShow"
      @close="closeActivityInfo"
    >
      TODO
    </ModalInfo>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import {required, minLength} from 'vuelidate/lib/validators';
import {loginMethods} from '@/constant/env.js';
import {
  isValidPhoneNumber,
  getInternationalPhoneNumber,
  getUsernameByInternationalPhoneNumber,
} from '@/lib/validation/phoneNumber';
import ActionSheet from '@/components/Base/ActionSheet.vue';
import GoogleLoginButton from '@/components/Login/GoogleLoginButton.vue';
import AppleLoginButton from '@/components/Login/AppleLoginButton.vue';
import LineLoginButton from '@/components/Login/LineLoginButton.vue';
import GuestLoginButton from '@/components/Login/GuestLoginButton.vue';

import ModalInfo from '@/components/Modal/ModalInfo.vue';
import PageInfo from '@/components/Base/PageInfo.vue';

import BackEvent from '@/lib/base/backEvent.js';

import GoogleIcon from '@/assets/img/login/Google.png';
import AppleIcon from '@/assets/img/login/Apple.png';
import LineIcon from '@/assets/img/login/Line.png';
import LoginBgTop from '@/assets/img/login/login-bg-top.png';
import LoginBgBottom from '@/assets/img/login/login-bg-bottom.png';

import {
  getLocalData,
  saveLocalData,
  removeLocalData,
} from '@/lib/base/localData';
import delay from '@/lib/base/delay';
import {getI18nImage} from '@/i18n/utils';

export default {
  metaInfo() {
    return {
      title: this.$t('登入') + '｜' + this.$t('黑嘉嘉圍棋'),
    };
  },
  name: 'Login',
  components: {
    ActionSheet,
    GoogleLoginButton,
    AppleLoginButton,
    LineLoginButton,
    ModalInfo,
    PageInfo,
    GuestLoginButton,
  },
  data() {
    return {
      activeTab: 'email',
      slide: 0,
      formData: {
        phoneNum: '',
        password: '',
        isUsernameValid: null,
        isPasswordValid: null,
        currentCallingCode: '',
        currentRegionCode: '',
        email: '',
        activityAccount: '',
      },
      isActivityInfoModalShow: false,
      showPassword: false,
      backendError: '',
      isRegionEditing: false,
      isAccountRemembered: false,
      carouselArr: [
        {
          key: 'carousel1',
          imgUrl: getI18nImage(
            '@/assets/img/locales/{locale}/login/web_login_1_tc.png'
          ),
          text: this.$t('準備好和我一起進入圍棋的世界了嗎？'),
          subText: this.$t('黑嘉嘉圍棋'),
        },
        {
          key: 'carousel2',
          imgUrl: getI18nImage(
            '@/assets/img/locales/{locale}/login/web_login_2_tc.png'
          ),
          text: this.$t('由淺入深，量身打造學習體驗'),
          subText: this.$t('黑嘉嘉圍棋'),
        },
        {
          key: 'carousel3',
          imgUrl: getI18nImage(
            '@/assets/img/locales/{locale}/login/web_login_3_tc.png'
          ),
          text: this.$t('通過線上檢定，取得棋力證書'),
          subText: this.$t('黑嘉嘉圍棋'),
        },
      ],
      loginMethods,
      GoogleIcon,
      AppleIcon,
      LineIcon,
      LoginBgTop,
      LoginBgBottom,
    };
  },
  validations: {
    formData: {
      phoneNum: {
        required,
        isValid: (value, vm) => {
          if (vm.currentRegionCode === 'TW') return true;
          return isValidPhoneNumber(vm.phoneNum, vm.currentRegionCode);
        },
      },
      password: {required, minLength: minLength(8)},
      email: {
        required,
      },
      activityAccount: {
        required,
      },
    },
  },
  computed: {
    ...mapState('env', ['local', 'localeName', 'localeList']),
    ...mapGetters('env', ['isIos', 'isAndroid']),
    regionCodes() {
      return this.$store.getters['env/regionCodes'];
    },
    isLoading() {
      return this.$store.state.env.isLoading;
    },
    plans() {
      return this.$store.getters['course/plans'];
    },
    internationalPhoneNumber() {
      if (!this.isValidPhoneNumber) {
        return '';
      }

      return getInternationalPhoneNumber(
        this.formData.currentCallingCode + this.formData.phoneNum
      );
    },
    username() {
      if (!this.isValidPhoneNumber) {
        return '';
      }

      return getUsernameByInternationalPhoneNumber(
        this.internationalPhoneNumber
      );
    },
    isValidPhoneNumber() {
      if (this.formData.currentRegionCode === 'TW')
        return this.formData.currentCallingCode + this.formData.phoneNum;
      return isValidPhoneNumber(
        this.formData.currentCallingCode + this.formData.phoneNum
      );
    },
    redirect() {
      return this.$route.query.redirect;
    },
    upperBgWidth() {
      const width = '240px';
      return {
        width,
      };
    },
  },
  mounted() {
    this.formData.currentRegionCode = 'TW';
    this.formData.currentCallingCode = '+886';
    const loginType = getLocalData('login-type');
    if (loginType) this.activeTab = loginType;

    const rememberedAccount = getLocalData('remembered-account');
    if (rememberedAccount) {
      this.isAccountRemembered = true;
      switch (loginType) {
        case 'email':
          this.formData.email = rememberedAccount;
          break;
        case 'phone':
          this.formData.phoneNum = rememberedAccount;
          break;
        default:
          this.formData.activityAccount = rememberedAccount;
          break;
      }
    }
  },
  methods: {
    ...mapActions('env', ['openChangeLocaleModal', 'changeLocale']),
    getRedirectData() {
      try {
        const next = this.$route.query.next;
        return JSON.parse(next);
      } catch {
        return {};
      }
    },
    initialData(event) {
      this.formData.isUsernameValid = null;
      this.formData.isPasswordValid = null;
      this.activeTab = event;
    },
    gotoWitQuery(name) {
      this.$router.push({name, query: this.$route.query});
    },
    async requestLogin(value) {
      if (this.isLoading) return;
      if (value === 'email') {
        const email = this.formData.email;
        if (/^[0-9]+$/.test(email)) {
          return this.$Message.error(this.$t('手機號碼請至下方的手機登入'));
        }
      }
      if (value === 'phone') {
        const phoneNum = this.formData.phoneNum;
        if (!/^[0-9]+$/.test(phoneNum)) {
          return this.$Message.error(
            this.$t('帳號或電子信箱請至下方的帳號登入')
          );
        }
      }

      let invalid = false;
      if (value === 'email') {
        invalid =
          this.$v.formData.email.$invalid || this.$v.formData.password.$invalid;
      } else if (value === 'phone') {
        invalid =
          this.$v.formData.phoneNum.$invalid ||
          this.$v.formData.password.$invalid;
      } else {
        invalid =
          this.$v.formData.activityAccount.$invalid ||
          this.$v.formData.password.$invalid;
      }

      this.formData.isUsernameValid = null;
      this.formData.isPasswordValid = null;
      if (invalid) {
        this.$v.$touch();
        // 由於b-form-input之驗證方法通過時(true)會出現預設打勾樣式，不符UI需求，故維持(null)無樣式
        this.formData.isUsernameValid = this.validateUsername() ? null : false;
        this.formData.isPasswordValid = this.validatePassword() ? null : false;
        if (!this.validateUsername()) {
          switch (value) {
            case 'email':
              this.$refs.email.focus();
              break;
            case 'phone':
              this.$refs.phoneNum.focus();
              break;
            default:
              this.$refs.activityAccount.focus();
              break;
          }
        } else if (!this.validatePassword()) {
          this.$refs.password.focus();
        }
        return false;
      } else {
        await this.loginUser(value);
      }
    },
    async loginUser(value) {
      this.$store.commit('env/setIsLoading', true);
      try {
        let username = '';
        switch (value) {
          case 'email':
            username = this.formData.email;
            break;
          case 'phone':
            username = this.username;
            break;
          default:
            username = this.formData.activityAccount;
            break;
        }
        await this.$store.dispatch('user/login', {
          username,
          password: this.formData.password,
          language: this.local,
        });
        await this.$store.dispatch('user/loginWithJwt');
        saveLocalData('login-type', value);
        if (this.isAccountRemembered) {
          let rememberedAccount = '';
          switch (value) {
            case 'email':
              rememberedAccount = this.formData.email;
              break;
            case 'phone':
              rememberedAccount = this.formData.phoneNum;
              break;
            default:
              rememberedAccount = this.formData.activityAccount;
              break;
          }
          saveLocalData('remembered-account', rememberedAccount);
        } else {
          removeLocalData('remembered-account');
        }

        this.$JPush.updateTags();
        const redirectData = {name: 'home', ...this.getRedirectData()};
        await this.$router.push(redirectData);
        this.$store.commit('env/setIsLoading', false);
      } catch (error) {
        this.backendError =
          error?.message ===
          'The string supplied did not seem to be a phone number'
            ? 'wrong format'
            : error?.response?.data.message;
        if (this.backendError === 'Wrong password!') {
          this.formData.isPasswordValid = false;
        } else {
          this.formData.isUsernameValid = false;
        }
        this.$store.commit('env/setIsLoading', false);
      }
    },
    validateUsername() {
      // Vuelidate使用方式: https://bootstrap-vue.org/docs/reference/validation

      let error = false;
      switch (this.activeTab) {
        case 'email':
          error = this.$v.formData.email.$error;
          break;
        case 'phone':
          error = this.$v.formData.phoneNum.$error;
          break;
        default:
          error = this.$v.formData.activityAccount.$error;
          break;
      }

      if (this.backendError !== '') {
        // api回傳錯誤訊息
        return false;
      } else {
        // 尚未打api前，Vuelidate的錯誤訊息
        return !error;
      }
    },
    validatePassword() {
      const {$error} = this.$v.formData.password;
      if (this.backendError !== '') {
        return false;
      } else {
        return !$error;
      }
    },
    usernameInputHandler() {
      this.backendError = '';
      this.formData.isUsernameValid = null;
    },
    passwordInputHandler() {
      this.backendError = '';
      this.formData.isPasswordValid = null;
    },
    closeEdit() {
      BackEvent.popEvent();
      this.isRegionEditing = false;
    },

    sheetEvent(callingCode, regionCode) {
      this.formData.isUsernameValid = null;
      this.formData.isPasswordValid = null;
      this.formData.currentCallingCode = callingCode;
      this.formData.currentRegionCode = regionCode;
      this.closeEdit();
    },
    onClickOpenActivityInfoModal() {
      this.isActivityInfoModalShow = true;

      if (this.$device.isMobile) {
        BackEvent.addEvent(() => {
          this.closeActivityInfo();
        });
      }
    },
    async closeActivityInfo() {
      await delay(100);
      BackEvent.popEvent();
      this.isActivityInfoModalShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: white;
  .logo {
    position: absolute;
    top: 0;
    z-index: 10;
  }

  @media screen and (min-width: 768px) {
    width: 450px;
    height: calc(
      100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom)
    );
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
  }

  .thirdparty-login-text {
    color: $font-grayscale-2;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .dash {
      height: 1px;
      background: $line-2;
    }
    .text-content {
      flex-shrink: 0;
    }
  }
  .wrap-oauth-login-btn {
    margin: 0 12px;
  }

  .oauth-login-btn {
    border: 1px solid #000;
    cursor: pointer;
    border-radius: 14px;
    padding: 12px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 20px;
    }
  }
  .oauth-login-btn-text {
    font-size: 12px;
    color: $font-normal;
    line-height: 20px;
    margin-top: 4px;
    text-align: center;
  }
  .upper-bg {
    height: 100%;
    @media screen and (min-width: 768px) {
      height: auto;
      margin-bottom: 24px;
    }
    .hello-cn {
      font-size: 32px;
      height: 45px;
    }
    .start-cn {
      font-size: 20px;
      height: 32px;
    }
    .hello {
      font-size: 28px;
      height: 44px;
    }
    .start {
      font-size: 20px;
      height: 32px;
    }
    .account-input {
      .region {
        width: 86px;
        font-size: 14px;
        background-color: white;
        color: $font-normal;
        border-right: none;
        border-radius: 4px 0 0 4px;
        border-color: $disable;
        span {
          height: 20px;
          font-size: 14px;
        }
        i {
          font-size: 16px;
          color: $primary;
        }
      }
    }
    .password-input {
      margin-bottom: 16px;
    }

    .forget {
      font-size: 12px;
      color: $font-grayscale-1;
      text-decoration: underline;
    }
    .error {
      margin-top: 4px;
      height: 16px;
      color: $negative;
      font-size: 12px;
      text-align: start;
    }
    .dividers {
      border-top: 1px solid #dcdfe5;
    }
    :deep() .login-register-tabs {
      li {
        .login-register-tab {
          border-top: 1px solid $secondary;
          border-bottom: 1px solid $secondary;
          border-right: 1px solid $secondary;
          border-radius: 0;
          padding: 4px 0;
          line-height: 28px;
          &:not(.active) {
            background: $white;
            color: $secondary;
            &:hover {
              color: #ffab36;
            }
          }
        }

        &:first-child {
          .login-register-tab {
            border-left: 1px solid $secondary;
            border-radius: 4px 0px 0px 4px;
          }
        }
        &:last-child {
          .login-register-tab {
            border-radius: 0px 4px 4px 0px;
          }
        }
      }
    }
  }

  .content {
    height: calc(100vh - 120px);
    overflow: overlay;
    justify-content: center;
    flex-direction: column;
  }
  .bottom-bg {
    background: #fcedd5;
    line-height: 28px;
    padding: 16px 0;
    @media screen and (min-width: 768px) {
      height: auto;
      background: white;
      padding: 0;
    }
    .custom-control-label {
      > a {
        color: $font-normal;
        text-decoration: underline;
      }
    }
    .no-account {
      text-align: center;
      .signup {
        color: $accent;
        text-decoration: underline;
      }
    }
  }
  .form-control {
    font-size: 14px;
  }
}
.jungo-logo {
  width: 100px;
  top: 32px;
  left: 32px;
  z-index: 10;
}
.wrap-banner {
  background: $bgsection;
  .banner-container {
    max-height: 100vh;
    .banner {
      object-fit: cover;
      height: calc(100vh - 305px - 80px);
      max-width: 100%;
      max-height: 790px;
    }
  }
  .app-title {
    height: 305px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .title {
      font-size: 40px;
    }
  }
}
.list-group-item-action {
  height: 51px;
  border-bottom: 1px solid rgba(199, 199, 199, 0.3);
  color: $font-normal;
}
.bottom-text {
  bottom: 58px;
  .caption {
    height: 44px;
  }
  .carousel-content {
    height: 28px;
    color: $font-grayscale-2;
  }
}
:deep() ol {
  margin-block-end: 32px;
  li {
    background-color: $secondary;
    opacity: 0.5;
    &.active {
      opacity: 1;
    }
  }
}
.dropdown {
  width: 92px;
  height: 35px;
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  .customDropdown {
    background-color: #fff;
    border: 1px solid #ced4da;
    color: $primary;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .dropdown-menu {
    li {
      width: 230px;
    }
  }
}
.carousel-img {
  object-fit: cover;
  max-width: 1200px;
  height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
}
.jungo-carousel-img {
  object-fit: cover;
  max-width: 512px;
  height: 512px;
}
.login-locale {
  min-width: 108px;
  min-height: 36px;
  border: none;
}
</style>
